export default {
    paymintApiUrl: 'https://paymint-appsrv-route-afd-gpfwbuf7fphve8hg.a03.azurefd.net',
    clientId: '62125a8c-6d62-4216-97cc-ddfde0dbdf06',
    authority:'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2, // Default to Warning level
    sampleRate: 0.5
};